export default __webpack_public_path__ + "3b65df91d40392ca3fb6df3d49f806b5.svg";